import { render, staticRenderFns } from "./AlarmorderHandleModal.vue?vue&type=template&id=b3913598&"
import script from "./AlarmorderHandleModal.vue?vue&type=script&lang=js&"
export * from "./AlarmorderHandleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports